import { useParams } from 'react-router-dom';

import {
  EditCampaignProvider,
  useEditCampaignContext,
} from '@/contexts/edit-campaign-context';
import { useWxCopilotSourceContext } from '@/hooks/use-wx-copilot-source-context';
import {
  sourceCampaignContext,
  sourceCampaignChannelContext,
} from '@/utils/source-copilot-context';

import { OtherChannelsDialog } from './other-channels';
import { ReachCampaignPage } from './reach';

function EditCampaignContent() {
  const { channelSlug, openingSlug } = useParams();
  const { campaign, campaignOpening, selectedPublisher } =
    useEditCampaignContext();
  const sourceCampaign = campaign
    ? sourceCampaignContext(campaign, campaignOpening?.openingId)
    : undefined;
  useWxCopilotSourceContext('editor', {
    ...(!openingSlug && campaignOpening
      ? {
          sourceOpening: {
            id: campaignOpening.openingId,
            name: campaignOpening.openingName,
          },
        }
      : {}),
    sourceCampaign,
    sourceChannel: sourceCampaign
      ? [
          selectedPublisher
            ? {
                id: selectedPublisher.sourcing_channel.external_id,
                name: selectedPublisher.sourcing_channel.name,
                slug: selectedPublisher.sourcing_channel.slug,
                campaignId: sourceCampaign.id,
                publisherId: selectedPublisher.reach_campaign_id,
                status: selectedPublisher.status,
                budget: selectedPublisher.budget,
                budgetType: selectedPublisher.budget_type,
                spend: selectedPublisher.budget_spent,
                startDate: selectedPublisher.starts_at,
                endDate: selectedPublisher.end_at,
                timeZone: sourceCampaign.timeZone,
              }
            : sourceCampaignChannelContext(sourceCampaign),
        ]
      : undefined,
  });

  if (channelSlug) {
    return <OtherChannelsDialog channelSlug={channelSlug} />;
  }

  return <ReachCampaignPage />;
}

export function EditCampaign() {
  return (
    <EditCampaignProvider>
      <EditCampaignContent />
    </EditCampaignProvider>
  );
}
